import React, { forwardRef } from 'react';
import _classNames from 'classnames';
import { IconButton, makeStyles, withStyles } from '@material-ui/core';
import { HeartIcon } from '../icons/HeartIcon';

const useStyles = makeStyles(theme => ({
  heartButton: {
    padding: 4,
    marginRight: theme.spacing(2),
    color: '#8899A6',
  },
  saved: {
    color: theme.palette.primary.secondary,
    '& svg': {
      fill: theme.palette.primary.secondary,
    },
  },
  animated: {
    animation: `pulse 750ms linear infinite`,
    '& svg': {
      color: theme.palette.primary.secondary,
      animation: `svgFadeOut 750ms linear infinite`,
    },
  },
}));

const globalStyles = theme => ({
  '@global': {
    '@keyframes pulse': {
      '0%': {
        transform: 'scale(1)',
      },
      '50%': {
        transform: 'scale(1.2)',
      },
      '75%': {
        transform: 'scale(0.9)',
      },
      '100%': {
        transform: 'scale(1)',
      },
    },
    '@keyframes svgFadeOut': {
      '0%': {
        fill: theme.palette.primary.secondary,
        fillOpacity: 1,
      },
      '100%': {
        fillOpacity: 0,
      },
    },
  },
});

export const SeriesHeartButton = withStyles(globalStyles)(
  forwardRef(({ saved, animated, handleSave, ...rest }, ref) => {
    const classes = useStyles();

    return (
      <IconButton
        {...rest}
        className={_classNames(classes.heartButton, {
          [classes.saved]: saved,
          [classes.animated]: animated,
        })}
        onClick={handleSave}
        aria-label="Favorite"
        ref={ref}
      >
        <HeartIcon />
      </IconButton>
    );
  }),
);
